import { Routes } from '@angular/router';
import { accountRoutes } from './features/account/account.routes';
import { applicationRoutes } from './features/application/application.routes';
import { authRoutes } from './features/auth/auth.routes';
import { programRoutes } from './features/program/program.routes';
import { providerRoutes } from './features/provider/provider.routes';
import { supportRoutes } from './features/support/support.routes';
import { HomeComponent } from './pages/home/home.component';

const appRoutes: Routes = [
    { path: ':clientCode/home', component: HomeComponent },
    {
        path: ':clientCode/providers/:providerId/programs/:programIds',
        component: HomeComponent
    },
    {
        path: ':clientCode/providers/:providerId',
        component: HomeComponent
    },
    {
        path: ':clientCode',
        component: HomeComponent,
        pathMatch: 'full'
    },
    {
        path: '**',
        redirectTo: ':clientCode/home',
        pathMatch: 'full'
    }
];
export const routes: Routes = [
    ...authRoutes,
    ...supportRoutes,
    ...providerRoutes,
    ...programRoutes,
    ...applicationRoutes,
    ...accountRoutes,
    ...appRoutes
];
